import React from 'react';
import Slider from '@mui/material/Slider';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { formatCurrency } from '../../helpers/format-helper';
import { Box } from '@mui/material';

export default function LoanSlider({ defaultValue, min, max, step, onChange }) {

    if (defaultValue == null) return null;

    const customSliderTheme = createTheme({
        components: {
            MuiSlider: {
                styleOverrides: {
                    valueLabel: {
                        padding: '5px 12px',
                        borderRadius: '5px',
                        fontSize: '1.4rem',
                        fontWeight: 'bold'
                    },
                    thumb: {
                        color: "var(--color-primary)",
                    },
                    track: {
                        color: 'var(--color-primary)'
                    },
                    rail: {
                        color: '#c5cbd4'
                    }
                },
            },
        }
    });

    return (
        <Box sx={{ pt: 1, pb: 3 }}>
            <ThemeProvider theme={customSliderTheme}>
                <Slider
                    key={`slider-${defaultValue}`} /* fixed issue */
                    defaultValue={defaultValue}
                    getAriaValueText={formatCurrency}
                    step={step}
                    min={min}
                    max={max}
                    valueLabelDisplay="on"
                    valueLabelFormat={formatCurrency}
                    onChangeCommitted={onChange}
                />
            </ThemeProvider>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>Min: {formatCurrency(min)}</div>
                <div>Máx: {formatCurrency(max)}</div>
            </Box>
        </Box>
    )

}
